interface CarouselItem {
  image: string;
  imageAlt: string;
  tag: string;
  title: string;
  desc: string;
  badge: string;
}

const carouselItems: CarouselItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20scene%20with%20paparazzi%20camera%20flashes%2C%20warm%20coral%20and%20amber%20lighting%2C%20dark%20cinematic%20atmosphere%2C%20editorial%20photography%20style%2C%20no%20recognizable%20faces&width=600&height=400&seq=carousel-01-91cg&orientation=landscape",
    imageAlt: "年度最大瓜独家揭秘",
    tag: '独家深度',
    title: '年度最大瓜：顶流艺人婚变内幕全解析',
    desc: '从相识到分道扬镳，时间线完整梳理，多方信源交叉印证，还原事件真实面貌。',
    badge: '🔥 爆款',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Live%20streaming%20platform%20controversy%20scene%2C%20dramatic%20warm%20lighting%2C%20modern%20studio%20setting%2C%20editorial%20photography%2C%20dark%20cinematic%20atmosphere%2C%20no%20faces&width=600&height=400&seq=carousel-02-91cg&orientation=landscape",
    imageAlt: "直播圈大地震",
    tag: '深度报道',
    title: '直播圈大地震：头部主播集体跳槽背后的资本博弈',
    desc: '平台挖角大战白热化，数位千万粉丝主播一夜换平台，签约金额刷新行业纪录。',
    badge: '📰 深度',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Reality%20show%20drama%20scene%20with%20dramatic%20spotlights%2C%20warm%20amber%20and%20rose%20tones%2C%20dark%20cinematic%20atmosphere%2C%20editorial%20style%2C%20no%20faces&width=600&height=400&seq=carousel-03-91cg&orientation=landscape",
    imageAlt: "选秀节目黑幕",
    tag: '调查报道',
    title: '选秀节目投票黑幕：前工作人员爆料惊人操作',
    desc: '自称某选秀节目前员工匿名投稿，揭露排名操控和评委潜规则的完整操作链。',
    badge: '⚡ 独家',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Celebrity%20couple%20scandal%20themed%20dramatic%20scene%2C%20warm%20dark%20lighting%2C%20editorial%20photography%2C%20cinematic%20atmosphere%2C%20no%20faces&width=600&height=400&seq=carousel-04-91cg&orientation=landscape",
    imageAlt: "明星恋情时间线",
    tag: '时间线',
    title: '从暗恋到官宣：年度最甜CP恋情发展完整时间线',
    desc: '历时三年追踪，整理这对明星CP从暧昧互动到正式公开的每一个关键节点。',
    badge: '💕 甜瓜',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Fashion%20award%20ceremony%20dramatic%20scene%20with%20red%20carpet%2C%20warm%20amber%20lighting%2C%20dark%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20no%20faces&width=600&height=400&seq=carousel-05-91cg&orientation=landscape",
    imageAlt: "颁奖典礼名场面",
    tag: '回顾专题',
    title: '名场面回顾：近五年颁奖典礼上最尴尬的十个瞬间',
    desc: '从口误到摔跤，从冷场到互怼，带你重温那些让观众脚趾抠地的名场面。',
    badge: '🎬 回顾',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Internet%20meme%20culture%20abstract%20collage%2C%20warm%20coral%20and%20amber%20tones%2C%20modern%20editorial%20design%2C%20dark%20background%2C%20clean%20composition&width=600&height=400&seq=carousel-06-91cg&orientation=landscape",
    imageAlt: "网络热梗起源",
    tag: '文化解读',
    title: '网络热梗考古：那些刷爆你朋友圈的梗都是从哪来的',
    desc: '2026上半年最火的网络热梗起源考据，每一个都曾霸占你的社交媒体首页。',
    badge: '🧐 考古',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-2">焦点专题</h2>
        <p className="text-foreground-500 text-sm text-center mb-10">编辑精选深度专题，全方位吃透每个大瓜</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-200/50 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-white text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium whitespace-nowrap">
                  {item.badge}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-medium text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}